export const blockIconsMapsNorthEastNew = (
	<span className='material-symbols-outlined'>north_east</span>
);
